import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { DailyPlantPerformanceSummaryPage } from '../daily-plant-performance-summary.page';

@Component({
  standalone: true,
  selector: 'app-dpmr-report-page',
  imports: [CommonModule, FormsModule, LucideAngularModule],
  templateUrl: './dpmr-report.page.html',
  styleUrl: './dpmr-report.page.scss',
})
export class DpmrReportPage extends DailyPlantPerformanceSummaryPage {}
